module.exports = __webpack_public_path__ + "assets/pdf/E11-en-flood-footprint-assessment.ff714608.pdf";